import axios from 'axios'
import numeral from 'numeral'
import numeralLocale from 'numeral/locales/ru'
import moment from 'moment'

const debug = process.env.NODE_ENV !== 'production'

const csrfToken = global.Laravel.csrfToken
const baseUrl = global.Laravel.url
const userId = global.Laravel.userId // todo: хранить где то в js все данные пользователя ?? (лучше наверно запросом получить)
const broadcasting = global.Laravel.broadcasting

/**
 * Эти заголовки должны быть добавлены ко всем запросам.
 */
export const headers = {
  'X-CSRF-TOKEN': csrfToken,
  'X-Requested-With': 'XMLHttpRequest'
}

/**
 * Подготовленный для запросов к локальному серверу instance axios.
 */
export const localAxios = axios.create({
  baseURL: baseUrl,
  headers
})

// numeral.register('locale', 'ru', numeralLocale)
numeral.locale('ru', numeralLocale)
moment.locale('ru')

/**
 * Экспортируем глобальные библиотеки требующие инициализации.
 */
export {
  // константы
  debug,
  csrfToken,
  baseUrl,
  userId,
  broadcasting,

  // библиотеки
  numeral,
  moment
}



// WEBPACK FOOTER //
// ./dev-packages/Core/assets/global.js